import { render, staticRenderFns } from "./MostrarContrato.vue?vue&type=template&id=283666c1&scoped=true&"
import script from "./MostrarContrato.vue?vue&type=script&lang=js&"
export * from "./MostrarContrato.vue?vue&type=script&lang=js&"
import style0 from "./MostrarContrato.vue?vue&type=style&index=0&id=283666c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283666c1",
  null
  
)

export default component.exports